import React, {useCallback, useEffect, useState} from 'react';
import {Alert, Box, Button, Chip, CircularProgress, Container, Paper, Stack, Typography} from '@mui/material';
import {Link as RouterLink} from 'react-router-dom';
import ApiService from '../network/API';
import AppealDialog from '../components/AppealDialog';

export const STATUS_LABEL = {OPEN: 'Ожидает ответа', ACCEPTED: 'Принято', REJECTED: 'Отклонено'};
export const STATUS_COLOR = {OPEN: 'warning', ACCEPTED: 'success', REJECTED: 'error'};

const fmtDate = (iso) => (iso ? new Date(iso).toLocaleString('ru-RU', {day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit'}) : '');

// Мои обращения: статус и ответ преподавателя; можно написать новое общее обращение.
const AppealsPage = () => {
    const [items, setItems] = useState(null);
    const [error, setError] = useState(null);
    const [open, setOpen] = useState(false);

    const load = useCallback(() => {
        ApiService.getMyAppeals().then(setItems).catch((e) => setError(e.reason || e.message || 'Не удалось загрузить обращения'));
    }, []);
    useEffect(load, [load]);

    return (
        <Container maxWidth="md" sx={{py: 4}}>
            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{mb: 3}} gap={2} flexWrap="wrap">
                <Typography variant="h5" fontWeight={700}>Мои обращения</Typography>
                <Button variant="contained" onClick={() => setOpen(true)}>Новое обращение</Button>
            </Stack>
            <Typography variant="body2" color="text.secondary" sx={{mb: 2}}>
                Обращение по конкретной задаче удобнее отправлять со страницы самой задачи — кнопка «Обратиться к преподавателю».
            </Typography>
            {error && <Alert severity="error">{error}</Alert>}
            {!items && !error && <Box textAlign="center" py={6}><CircularProgress size={28}/></Box>}
            {items && items.length === 0 && <Typography color="text.secondary">Обращений пока нет.</Typography>}
            <Stack spacing={2}>
                {(items || []).map((a) => (
                    <Paper key={a.id} variant="outlined" sx={{p: 2, borderRadius: 2}}>
                        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" gap={1} flexWrap="wrap">
                            <Typography fontWeight={700}>
                                {a.problemId ? <RouterLink to={`/problems/${a.problemId}`}>{a.problemTitle}</RouterLink> : 'Общее обращение'}
                                {a.articleTitle && <Typography component="span" color="text.secondary"> · {a.articleTitle}</Typography>}
                            </Typography>
                            <Chip size="small" color={STATUS_COLOR[a.status]} label={STATUS_LABEL[a.status]}/>
                        </Stack>
                        <Typography variant="caption" color="text.secondary">{fmtDate(a.createdAt)}</Typography>
                        <Typography sx={{mt: 1, whiteSpace: 'pre-wrap'}}>{a.text}</Typography>
                        {a.status !== 'OPEN' && (
                            <Alert severity={a.status === 'ACCEPTED' ? 'success' : 'error'} sx={{mt: 1.5}}>
                                {a.adminComment || (a.status === 'ACCEPTED' ? 'Обращение принято.' : 'Обращение отклонено.')}
                            </Alert>
                        )}
                    </Paper>
                ))}
            </Stack>
            <AppealDialog open={open} onClose={() => setOpen(false)} onSent={load}/>
        </Container>
    );
};

export default AppealsPage;
